import { FormFieldData } from './types';

export const ALLERGY_FORM_FIELD_DATA: FormFieldData[] = [
  {
    id: 'name',
    name: 'name',
    label: 'Allergy Name',
    placeholder: 'Add Allergy Name',
    buttonName: 'Continue',
    inputType: 'text',
    iconName: 'Pill',
    required: true,
  },
  {
    id: 'severity',
    name: 'severity',
    label: 'Allergy Severity',
    placeholder: 'Select Severity',
    buttonName: 'Save Allergy',
    inputType: 'select',
    iconName: 'Pill',
    required: true,
    options: [
      { label: 'Severe', value: 'Severe' },
      { label: 'Moderate', value: 'Moderate' },
      { label: 'Low', value: 'Low' },
    ],
  },
  {
    id: 'duration',
    name: 'duration',
    label: 'Duration',
    placeholder: 'Enter Duration',
    buttonName: 'Continue',
    inputType: 'duration',
    iconName: 'Pill',
    required: false,
  },
];
